import { QImg as e, QSelect as t } from "quasar";
import { computed as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, createVNode as s, defineComponent as c, mergeModels as l, nextTick as u, onBeforeMount as d, openBlock as f, ref as p, toDisplayString as m, unref as h, useModel as g, watch as _, withCtx as v } from "vue";
import { CMSNotification as y, SEARCH_DEBOUNCE as b, VuetifyValidationRules as x, getBaseUrlForBrand as S, registerEntityEndpoint as C, useNotificationStore as w } from "@editor/ui-utils";
import { getImage as T, getImageUrl as E } from "@modules/image-editor-ui-components";
import { useI18n as D } from "vue-i18n";
//#region src/components/partner-logo-block.vue?vue&type=script&setup=true&lang.ts
var O = {
	key: 0,
	class: "q-field--with-bottom"
}, k = { class: "absolute-full flex flex-center bg-negative text-white" }, A = /* @__PURE__ */ ((e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
})(/* @__PURE__ */ c({
	__name: "partner-logo-block",
	props: { logoUuid: { default: void 0 } },
	emits: ["isLoadingLogo"],
	setup(t, { emit: n }) {
		let r = t, c = n, { t: l } = D(), u = w(), d = p(void 0);
		return _(() => r.logoUuid, async () => {
			if (!r.logoUuid) {
				d.value = void 0;
				return;
			}
			try {
				c("isLoadingLogo", !0);
				let e = await T(r.logoUuid);
				d.value = E(e.image._id, e.image.width, e.image.height);
			} catch {
				u.showNotification(new y(l("partnerEdit.logoLoadError"), "negative")), d.value = void 0;
			} finally {
				c("isLoadingLogo", !1);
			}
		}), (n, r) => t.logoUuid ? (f(), a("div", O, [s(h(e), {
			class: "logo-style",
			src: d.value
		}, {
			error: v(() => [o("div", k, m(h(l)("partnerEdit.logoLoadError")), 1)]),
			_: 1
		}, 8, ["src"])])) : i("", !0);
	}
}), [["__scopeId", "data-v-0626d041"]]), j = "Partners", M = C(j), { listEntities: N, getEntity: P, postEntity: F, getEntityAPIClient: I } = M, L = I(), R = async (e, t = {}) => N({ params: {
	search: e,
	...t
} }), z = async (e) => P(e), B = async (e) => F(e), V = async (e) => await L.put(e._id, e), H = async (e, t) => await L.delete(`${e}${t ? `?onlyCTF=${t}` : ""}`), U = async () => {
	await L.post("sync/all");
}, W = async (e) => (await L.get(`sync/logo/${e}`)).data, G = async (e) => (await L.get(`sync/data/${e}`)).data, K = async (e, t) => F({
	partnerId: e,
	customPNumberRevShare: t
}), q = () => ({
	_id: "",
	name: "",
	partnerId: "",
	urlPartner: "https://www.someurl.com/",
	urlLogo: "https://www.someurl.com/",
	pNumberRevShare: "P0001",
	isActiveInCtf: !0,
	partnerType: "contentpartner",
	isLogoLinkFollow: !1
}), J = /* @__PURE__ */ c({
	__name: "partner-filter.selector",
	props: /* @__PURE__ */ l({
		multiple: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: { default: "" },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let { t: i } = D(), a = e, o = g(e, "modelValue"), s = p([]), c = n(() => s.value.map((e) => ({
			label: `${e.name}`,
			value: e._id
		}))), l = n(() => a.required ? [x.required] : []);
		function u(e, t) {
			t(async () => {
				let { list: t } = await R(e, { searchfields: ["name"] });
				s.value = t;
			});
		}
		let d = async () => {
			if (!o.value) return [];
			let e = Array.isArray(o.value) ? [...o.value] : [o.value], t = new Set(s.value.map((e) => e._id));
			return Promise.all(e.filter((e) => !t.has(e)).map(z));
		};
		return _(() => o.value, async () => {
			let { list: e } = await R();
			s.value = [...await d(), ...e];
		}, { immediate: !0 }), (n, a) => (f(), r(h(t), {
			modelValue: o.value,
			"onUpdate:modelValue": a[0] ||= (e) => o.value = e,
			"data-qa-partner-filter-dropdown": "",
			dense: "",
			outlined: "",
			label: h(i)("partnersSelector.selectPartner"),
			"use-chips": e.multiple,
			multiple: e.multiple,
			"input-debounce": h(b),
			"emit-value": "",
			"map-options": "",
			"use-input": "",
			clearable: !e.required,
			"clear-icon": e.required ? void 0 : "x",
			"dropdown-icon": "expand_more",
			disable: e.disable,
			options: c.value,
			rules: l.value,
			onFilter: u
		}, null, 8, [
			"modelValue",
			"label",
			"use-chips",
			"multiple",
			"input-debounce",
			"clearable",
			"clear-icon",
			"disable",
			"options",
			"rules"
		]));
	}
}), Y = /* @__PURE__ */ c({
	__name: "partner-list.selector",
	props: /* @__PURE__ */ l({
		partnerType: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		},
		showActiveInCtfOnly: {
			type: Boolean,
			default: !0
		}
	}, {
		modelValue: { default: void 0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let { t: i } = D(), a = e, o = g(e, "modelValue"), s = p([]), c = p(!1), l = p(1), m = p(!1), _ = p(""), v = n(() => s.value.map((e) => ({
			label: `${e.name}`,
			value: e._id
		}))), y = n(() => a.required ? [x.required] : []), S = async (e = !1) => {
			try {
				m.value = !0;
				let t = await R(_.value, {
					page: l.value,
					...a.partnerType ? { partnerType: a.partnerType } : {},
					...a.showActiveInCtfOnly ? { isActiveInCtf: !0 } : {},
					sortBy: "name",
					sortDesc: !1
				});
				e ? s.value = t.list : s.value = s.value.concat(t.list), t.next ? (l.value = t.page + 1, c.value = !0) : c.value = !1;
			} catch (e) {
				console.error("Failed to get Partners: ", e);
			} finally {
				u(() => {
					m.value = !1;
				});
			}
		};
		async function C({ index: e, ref: t }) {
			let n = v.value.length - 1;
			m.value !== !0 && c.value && e === n && (await S(!1), u(() => {
				t.refresh();
			}));
		}
		function w() {
			s.value = [], c.value = !0, l.value = 1;
		}
		function T(e, t) {
			t(async () => {
				_.value = e, w(), await S(!0);
			});
		}
		return d(async () => {
			if (o.value && !v.value.some((e) => e.value === o.value)) try {
				let e = await z(o.value);
				if (!e) return;
				s.value = [e];
			} catch (e) {
				console.error("Failed to get Partner: ", e);
			}
		}), (n, a) => (f(), r(h(t), {
			modelValue: o.value,
			"onUpdate:modelValue": a[0] ||= (e) => o.value = e,
			"data-qa-experts-user-filter-dropdown": "",
			dense: "",
			outlined: "",
			label: h(i)("partnersSelector.selectPartner"),
			"emit-value": "",
			"map-options": "",
			"use-input": "",
			clearable: !e.required,
			"clear-icon": e.required ? void 0 : "x",
			"dropdown-icon": "expand_more",
			disable: e.disable,
			options: v.value,
			rules: y.value,
			loading: m.value,
			"input-debounce": h(b),
			class: "partner-list-selector",
			onVirtualScroll: C,
			onFilter: T,
			onPopupHide: w
		}, null, 8, [
			"modelValue",
			"label",
			"clearable",
			"clear-icon",
			"disable",
			"options",
			"rules",
			"loading",
			"input-debounce"
		]));
	}
});
//#endregion
//#region src/utils/render.ts
function X(e) {
	return {
		brand: e,
		description: "",
		path: "",
		isNoIndex: !1
	};
}
var Z = (e, t, n) => {
	let r = S(t, "publish"), i = new URL(e, r);
	return n && i.searchParams.append("ctf", "override"), i.toString();
}, Q = (e) => `/partner/${e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "").toLowerCase()}/`, $ = {
	routes: [],
	messages: {
		en: {},
		de: {}
	}
};
//#endregion
export { J as PartnerFilterSelector, Y as PartnerListSelector, A as PartnerLogoBlock, j as PartnerModelName, M as PartnerService, H as deletePartner, Q as generateNormalizedPartnerRenderPath, q as getEmptyPartner, z as getPartner, R as getPartnerList, X as getPartnerRenderConfigDefaults, Z as getPartnerUrl, K as importPartnerFromSf, $ as partnerComponentsModule, B as postPartner, V as putPartner, U as syncAllPartners, G as syncPartnerData, W as syncPartnerLogo };

//# sourceMappingURL=index.es.js.map